import { render, staticRenderFns } from "./OrganizationsSettingsRow.vue?vue&type=template&id=b2556176&scoped=true"
import script from "./OrganizationsSettingsRow.vue?vue&type=script&lang=js"
export * from "./OrganizationsSettingsRow.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsSettingsRow.vue?vue&type=style&index=0&id=b2556176&prod&lang=scss"
import style1 from "./OrganizationsSettingsRow.vue?vue&type=style&index=1&id=b2556176&prod&lang=scss"
import style2 from "./OrganizationsSettingsRow.vue?vue&type=style&index=2&id=b2556176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2556176",
  null
  
)

export default component.exports